function AboutMe() {
    return (
    <div>
      <section className="about">
        <h3>About</h3>
        <p>I am learning the frontend developer with a particular interest in making things simple and automating daily tasks. I try to keep up with security and best practices, and am always looking for new things to learn.</p>
      </section>
      <section className="about">
        <h3>Interests</h3>
        <p>Learning to code. Listening to music. Piano. Internet fanatic. Play videogames. Entrepreneur. Travel geek. Wach movies.</p>
      </section>
    </div>
    );
  }
  
  export default AboutMe;